module.exports = __webpack_public_path__ + "img/title.a8a9791c.png";